
(function () {
    'use strict';
  
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    );
  
    const blocks = document.querySelectorAll('[data-description-clamp]');
  
    if (!blocks.length) return;
  
    const animations = new WeakMap();
  
    function getVisibleCopy(block) {
      const descriptions = block.querySelectorAll(
        '.collection-banner__description'
      );
  
      for (const element of descriptions) {
        if (getComputedStyle(element).display !== 'none') {
          return element;
        }
      }
  
      return null;
    }
  
    function cancelAnimation(block) {
      const cleanup = animations.get(block);
  
      if (cleanup) cleanup();
    }
  
    function syncClamp(block) {
      const button = block.querySelector('[data-read-more]');
      if (!button) return;
  
      if (!mobileQuery.matches) {
        cancelAnimation(block);
        block.classList.remove('is-expanded');
  
        block.querySelectorAll('.collection-banner__description')
          .forEach(function (copy) {
            copy.style.removeProperty('height');
          });
  
        button.hidden = true;
        button.textContent = 'Read more';
        return;
      }
  
      const expanded = block.classList.contains('is-expanded');
      button.textContent = expanded ? 'Read less' : 'Read more';
  
      if (expanded) {
        button.hidden = false;
        return;
      }
  
      const copy = getVisibleCopy(block);
  
      button.hidden = !copy ||
        copy.scrollHeight <= copy.clientHeight + 1;
    }
  
    function animateDescription(block, button) {
      if (!mobileQuery.matches) return;
  
      const copy = getVisibleCopy(block);
      if (!copy) return;

      cancelAnimation(block);
  
      const expanding = !block.classList.contains('is-expanded');
  
      if (reduceMotion.matches) {
        block.classList.toggle('is-expanded', expanding);
        copy.style.removeProperty('height');
        syncClamp(block);
        return;
      }
  
      const startHeight = copy.getBoundingClientRect().height;
  
      let endHeight;
  
      if (expanding) {
        block.classList.add('is-expanded');
        copy.style.height = 'auto';
        endHeight = copy.scrollHeight;
      } else {
        copy.style.removeProperty('height');
        block.classList.remove('is-expanded');
        endHeight = copy.getBoundingClientRect().height;
      }
  
      copy.style.height = startHeight + 'px';
      copy.offsetHeight;
  
      let timeoutId;
  
      function cleanup() {
        copy.removeEventListener('transitionend', finish);
        copy.removeEventListener('transitioncancel', finish);
        clearTimeout(timeoutId);
  
        if (animations.get(block) === cleanup) {
          animations.delete(block);
        }
      }
  
      function finish(event) {
        if (event && (
          event.target !== copy ||
          event.propertyName !== 'height'
        )) {
          return;
        }
  
        cleanup();
  
        // Don't overwrite a newer animation's state.
        if (Math.abs(copy.getBoundingClientRect().height - endHeight) > 1) {
          return;
        }
  
        copy.style.removeProperty('height');
        syncClamp(block);
      }
  
      animations.set(block, cleanup);
  
      copy.addEventListener('transitionend', finish);
      copy.addEventListener('transitioncancel', finish);
  
      button.textContent = expanding ? 'Read less' : 'Read more';
      copy.style.height = endHeight + 'px';
  
      timeoutId = setTimeout(function () {
        finish();
      }, 500);
    }
  
    blocks.forEach(function (block) {
      const button = block.querySelector('[data-read-more]');
      if (!button) return;
  
      button.addEventListener('click', function () {
        animateDescription(block, button);
      });
  
      syncClamp(block);
    });
  
    function syncAllBlocks() {
      blocks.forEach(syncClamp);
    }
  
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncAllBlocks);
    } else {
      mobileQuery.addListener(syncAllBlocks);
    }
})();